<template>
  <div class="contacto-view">
    <section id="contacto" class="py-5" style="background: linear-gradient(to bottom, #ece9e6, #ffffff); min-height: 80vh;">
      <div class="container mt-5 pt-5">
        <div class="text-center mb-5">
          <h1 class="display-4 font-weight-bold" style="color: #e74c3c; letter-spacing: 2px;">CONTÁCTANOS</h1>
          <p class="lead text-muted">Estamos listos para ayudarte con las mejores soluciones de empaques</p>
        </div>
        <div class="row align-items-stretch shadow-lg bg-white" style="border-radius: 20px; overflow: hidden;">
            <div class="col-lg-5 p-5" style="background-color: #f8f9fa; border-right: 1px solid #eee;">
              <h3 class="mb-4 font-weight-bold" style="color: #2c3e50;"><i class="fas fa-info-circle text-danger mr-2"></i> Información de Contacto</h3>
              <Datoscontacto></Datoscontacto>
            </div>
            <div class="col-lg-7 p-5">
              <h3 class="mb-4 font-weight-bold" style="color: #2c3e50;"><i class="fas fa-paper-plane text-danger mr-2"></i> Envíanos un Mensaje</h3>
              <Contacto></Contacto>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Contacto from '@/components/Contacto.vue'
import Datoscontacto from '@/components/Datoscontacto.vue'

export default {
  name: 'ContactoView',
  components: {
    Contacto,
    Datoscontacto
  }
}
</script>
